import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import ComponentQuery, {
	type RendererContentStateQuery$data,
	type RendererContentStateQuery$variables,
} from './__generated__/RendererContentStateQuery.graphql.ts';

export async function preloadRendererContentState(contentId: string): Promise<{
	data: RendererContentStateQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<RendererContentStateQuery$data, RendererContentStateQuery$variables>({
		query: ComponentQuery,
		variables: {
			contentId,
			isDraft: false,
			format: 'USER_FRIENDLY',
		},
		fetchPolicy: 'network-only',
	});
}
